import { render, staticRenderFns } from "./categoriafinanceira.vue?vue&type=template&id=2884f61a&"
import script from "./categoriafinanceira.vue?vue&type=script&lang=js&"
export * from "./categoriafinanceira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports